import notificationMessageReducer from './notification-messages';
import notificationMessageIndexReducer from './notification-message-indexes';
import scholarshipProgramSubjectsReducer from './scholarship-program-subjects';

export default {
  notificationMessageIndexes: notificationMessageIndexReducer,
  notificationMessages: notificationMessageReducer,
  scholarshipProgramSubjects: scholarshipProgramSubjectsReducer,
};
